import { LayoutHOC } from "base/ui/layout/layout";
import { createProductionPlanViewSlideDetails } from "./viewSlideDetails";



export const createProductionPlanViewSlideDetailsPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createProductionPlanViewSlideDetails());
};